import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule, LazyAction } from "owa-bundling";
import { getProtectYourAccountDialogStore } from "./store/store";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "OwaAccountProtectionDialog" */ "./lazyIndex"), { name: "OwaAccountProtectionDialog" });

/**
 * Entry point that wires up the "Protect your account" dialog: it subscribes to consumer account
 * startup, runs the MSA proof-state check, and shows the dialog (once per session) when needed.
 * Callers just kick this off; they do not orchestrate the UX.
 */
export const lazyInitializeAccountProofs: LazyAction<typeof lazyIndex.initializeAccountProofs, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeAccountProofs);

/**
 * App-tree host for the "Protect your account" dialog. Mount once (e.g. in AppModule); it only
 * imports and renders the dialog chunk once the store status is `Showing`.
 */
export const ProtectYourAccountDialogHost: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.ProtectYourAccountDialogHost, undefined, undefined, {
    onlyImportIf: () => getProtectYourAccountDialogStore().status === "Showing",
});
